import React from 'react';
import { FlameIcon } from 'lucide-react';
interface UrgencyBarProps {
  formattedTime: string;
  isExpired: boolean;
}
export function UrgencyBar({
  formattedTime,
  isExpired
}: UrgencyBarProps) {
  return <div className="sticky top-0 z-50 w-full py-2.5 px-4" style={{
    backgroundColor: '#1A0000'
  }} data-id="element-235">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-236">
        <div className="flex items-center gap-2 text-sm md:text-base text-body" data-id="element-237">
          <FlameIcon className="w-4 h-4 text-gold" data-id="element-238" />
          {isExpired ? <span data-id="element-239">La oferta ha expirado. Precio actual: $47.00</span> : <span className="text-center md:text-left" data-id="element-240">
              OFERTA DE TIEMPO LIMITADO — Tu descuento especial expira en:{' '}
              <span className="text-urgency-text text-xl font-bold ml-1" data-id="element-241">
                {formattedTime}
              </span>
            </span>}
        </div>
      </div>
    </div>;
}